module.exports = __webpack_public_path__ + "media/images/themes/could_touch/main_bg-28b852d275385ee7d61f6ca4b1d643ff.png";